export default {
  'Teklif Formu': 'Formulário de Cotação',
  'Kayıtlı Teklifler': 'Cotações Salvas',
  'Kullanıcı Adı': 'Nome de Usuário',
  'Şifre': 'Senha',
  'Giriş Yap': 'Entrar',
  'Çıkış Yap': 'Sair',
  'KDV Oranı': 'Taxa de IVA',
  'Teklif Durumu': 'Status da Cotação',
  'Kaydet': 'Salvar',
  'PDF Önizleme': 'Visualizar PDF',
  'PDF\'ye Aktar': 'Exportar para PDF',
  'E-posta ile Gönder': 'Enviar por Email',
  'Alıcı': 'Destinatário',
  'Tarih': 'Data',
  'Genel Toplam': 'Total Geral',
  'Not': 'Nota',
  'KDV': 'IVA',
  'Alt Toplam': 'Subtotal',
  'Açıklama': 'Descrição',
  'Ürün Adı': 'Nome do Produto',
  'SUT Kodu': 'Código SUT',
  'Birim Alış Fiyatı': 'Preço Unitário',
  'Sipariş Adedi': 'Quantidade do Pedido',
  'Promosyon Ürün': 'Produto Promocional',
  'Toplam Adet': 'Quantidade Total',
  'Sipariş Tutarı': 'Total do Pedido',
  'Durum': 'Status',
  'Kabul Edildi': 'Aceito',
  'Reddedildi': 'Rejeitado',
  'Gönderildi': 'Enviado',
  'Taslak': 'Rascunho',
  'Yurtiçi': 'Nacional',
  'Yurtdışı': 'Internacional',
  'Sipariş Oluştur': 'Criar Pedido',
  'Ürün Sıralaması': 'Ordenação de Produtos',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'Os produtos são ordenados por popularidade e importância',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'Produtos de cardiologia e cirurgia vascular são mostrados como prioridade',
  'Ürün adı, açıklama veya barkod ile ara...': 'Pesquisar por nome do produto, descrição ou código de barras...',
  'Tüm Kategoriler': 'Todas as Categorias',
  'Kutu görünüm': 'Vista de grade',
  'Liste görünüm': 'Vista de lista',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'Nenhum produto encontrado que corresponda aos seus critérios',
  'Ürün Adı Yok': 'Sem Nome do Produto',
  'Kategori Yok': 'Sem Categoria',
  'Açıklama yok': 'Sem descrição',
  'Firma Bilgilerini Doldurun': 'Preencher Informações da Empresa',
  'Sepete Ekle': 'Adicionar ao Carrinho',
  'Firma Bilgileri': 'Informações da Empresa',
  'Ülke Seçimi': 'Seleção de País',
  'Türkiye': 'Turquia',
  'Almanya': 'Alemanha',
  'ABD': 'Estados Unidos',
  'Firma Ünvanı': 'Nome da Empresa',
  'Vergi Dairesi': 'Repartição de Finanças',
  'Vergi Numarası': 'Número de Contribuinte',
  'Adres': 'Endereço',
  'Şehir': 'Cidade',
  'Şehir Seçimi': 'Seleção de Cidade',
  'Şehir Seçiniz': 'Selecionar Cidade',
  'Şehir adı ara...': 'Pesquisar nome da cidade...',
  'Aradığınız şehir bulunamadı': 'Cidade não encontrada',
  'Bu ülke için şehir verisi bulunamadı': 'Nenhum dado de cidade disponível para este país',
  'şehir bulundu': '{{count}} cidades encontradas',
  'Yetkili': 'Pessoa Autorizada',
  'Telefon': 'Telefone',
  'Email': 'Email',
  'Bilgileri İlet': 'Enviar Informações',
  'Lütfen eksik alanları doldurun': 'Por favor preencha os campos em falta',
  'Firma kaydedilemedi': 'A empresa não foi salva',
  'Firma bilgileri başarıyla iletildi': 'Informações da empresa enviadas com sucesso',
  'Firma Ünvanı:': 'Nome da Empresa:',
  'Yetkili Kişi:': 'Pessoa Autorizada:',
  'Sepetiniz': 'Seu Carrinho',
  'Sepetiniz boş': 'Seu carrinho está vazio',
  'adet': 'un',
  'Düzenle': 'Editar',
  'Kaldır': 'Remover',
  'Siparişi Tamamla': 'Completar Pedido',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'Por favor envie primeiro as informações completas da sua empresa',
  'Sipariş başarıyla kaydedildi': 'Pedido salvo com sucesso',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'Mensagem de boas-vindas e link de acesso enviados para o seu email',
  'Link 3 gün geçerlidir': 'O link é válido por 3 dias',
  'Sipariş kaydedilemedi': 'O pedido não foi salvo',
  'Firma Bilgileri Gerekli': 'Informações da Empresa Obrigatórias',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'Preencha primeiro as informações da empresa para adicionar ao carrinho',
  'Önce Bilgileri Doldurun': 'Preencha as Informações Primeiro',
  'Uyarı': 'Aviso',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'Você deve preencher primeiro as informações da empresa para adicionar ao carrinho',
  'SUT Kütüphanesi Tanımı': 'Definição da Biblioteca SUT',
  'SUT Kodu:': 'Código SUT:',
  'Standart': 'Padrão',
  'Açıklama (isteğe bağlı)': 'Descrição (opcional)',
  'Partner Ol': 'Tornar-se Parceiro',
  'Partner başvuru popup açılacak': 'O popup de candidatura de parceiro será aberto',
  'Dil': 'Idioma',
  'E-posta': 'Email',
  'E-Posta': 'Email',
  'Şifre': 'Senha',
  'Şifremi Unuttum': 'Esqueci a Senha',
  'Giriş yapılıyor...': 'Entrando...',
  'E-posta veya şifre hatalı': 'Email ou senha incorretos',
  'Şifre sıfırlama e-postası gönderildi': 'Email de redefinição de senha enviado',
  'E-posta gönderilemedi': 'O email não foi enviado',
  'Üye Ol': 'Registrar',
  'Üye Değil Misiniz?': 'Não é membro?',
  'Şimdi Üye Ol': 'Registrar Agora',
  'Misafir Kullanıcı': 'Usuário Convidado',
  'Hızlı Sipariş': 'Pedido Rápido',
  'Misafir Olarak Sipariş Verin': 'Pedir como Convidado',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'Selecione rapidamente seus produtos e crie seu pedido sem fazer login',
  'Giriş yapmadan sipariş oluşturun': 'Criar pedido sem fazer login',
  'Anında Erişim': 'Acesso Instantâneo',
  'Tüm ürünlere anında erişim': 'Acesso instantâneo a todos os produtos',
  'Güvenli İşlem': 'Transação Segura',
  'SSL korumalı güvenli sipariş': 'Pedido seguro protegido por SSL',
  'Misafir Olarak Sipariş Oluştur': 'Criar Pedido como Convidado',
  'İpucu:': 'Dica:',
  'Daha fazla özellik için üye olun': 'Registre-se para mais funcionalidades',
  'Ücretsiz': 'Gratuito',
  'Hızlı': 'Rápido',
  'Güvenli': 'Seguro',
  'bayilikSozlesme': 'Li e aceito os termos e condições de parceria da INVAMED.',
  'geri': 'Voltar',
  'basvuruGonder': 'Enviar Candidatura',
  'ileri': 'Próximo',
  'sozlesmeGonderildi': 'Contrato Enviado para o Seu Email!',
  'sozlesmeDesc': 'Por favor faça upload do Contrato de Parceria INVAMED e documentos necessários enviados para seu email abaixo.',
  'tamamla': 'Completar Candidatura',
  'basvuruAlindi': 'Sua Candidatura Foi Recebida!',
  'basvuruAlindiDesc': 'A equipe INVAMED revisará sua candidatura e entrará em contato o mais breve possível.',
  'Başvuru Durumu': 'Status da candidatura',
  'Başvurunuz onay sürecindedir': 'Sua candidatura está sendo revisada',
  'sifreSifirla': 'Redefinir Senha',
  'sifreSifirlaDesc': 'Digite seu email registrado e enviaremos instruções para redefinir sua senha.',
  'gonder': 'Enviar',
  'talimatGonderildi': 'Instruções Enviadas',
  'sentDesc': 'As instruções para redefinir a senha foram enviadas para <b>{email}</b>. Por favor verifique seu email.',
  'helpTitle': 'Como posso fazer login?',
  'helpList': [
    'Para fazer login no painel de distribuidores INVAMED, digite seu email registrado e senha.',
    'Para fazer login com o usuário demo:',
    'Se você esqueceu sua senha, use o link "Esqueci a Senha" para solicitar uma redefinição.',
    'Se você tem problemas de login, certifique-se de que seu email e senha estão corretos. Se o problema persistir, entre em contato com nossa equipe de suporte.'
  ],
  'partnerlikSozlesmeTitle': 'Acordo de Parceria INVAMED e Termos',
  'partnerlikSozlesmeText': `1. DISPOSIÇÕES GERAIS

Este acordo é celebrado entre INVAMED (doravante referida como "Empresa") e o candidato a parceiro (doravante referido como "Parceiro") para fins de cooperação na venda de dispositivos médicos e equipamentos.

2. CONDIÇÕES DE PARCERIA

2.1. O Parceiro deve ter autoridade legal para a venda de dispositivos médicos.
2.2. O Parceiro deve ser uma organização operando no setor de saúde.
2.3. O Parceiro deve ter as licenças e certificados necessários.
2.4. O Parceiro deve ser financeiramente confiável.

3. OBRIGAÇÕES DAS PARTES

Obrigações da Empresa:
3.1. Fornecer produtos e serviços de qualidade
3.2. Fornecer suporte técnico
3.3. Fornecer treinamento e informações
3.4. Ser transparente sobre preços

Obrigações do Parceiro:
3.1. Armazenar produtos em condições apropriadas
3.2. Fornecer serviço ao cliente de qualidade
3.3. Cumprir regulamentações legais
3.4. Proteger a marca da empresa

4. FIXAÇÃO DE PREÇOS E PAGAMENTO

4.1. Os preços são determinados pela Empresa
4.2. O Parceiro é obrigado a manter os preços determinados
4.3. Os termos de pagamento são determinados separadamente
4.4. As taxas de comissão podem variar de acordo com o desempenho

5. CONFIDENCIALIDADE E SEGURANÇA

5.1. As partes são obrigadas a proteger as informações confidenciais de cada uma
5.2. As informações do cliente devem ser mantidas confidenciais
5.3. Os padrões de segurança de dados devem ser cumpridos

6. DURAÇÃO E RESCISÃO DO ACORDO

6.1. Este acordo é válido por 1 ano
6.2. Pode ser estendido por acordo mútuo
6.3. Pode ser rescindido com aviso prévio de 30 dias
6.4. Pode ser rescindido imediatamente em caso de violação grave

7. RESOLUÇÃO DE DISPUTAS

7.1. As disputas são principalmente tentadas de serem resolvidas através de negociação
7.2. Os tribunais da República da Turquia são autorizados para casos não resolvidos

8. EFICÁCIA

Este acordo foi lido, entendido e aceito pelas partes.`,
  'partnerlikSozlesmeOnay': 'Li, entendi e aceito o Acordo de Parceria INVAMED e Termos acima. Declaro que aceito todos os artigos deste acordo e cumprirei minhas obrigações.',
  'sozlesmeyiGoruntule': 'Ver Acordo',
  'sozlesmeyiKapat': 'Fechar',
  'Ürün': 'Produto',
  'Ürün eklemek için ürün listesinden seçim yapın': 'Selecione produtos da lista para adicionar ao carrinho',
  'Etiketler': 'Etiquetas',
  'Öncelikli': 'Prioridade',
  'Kapat': 'Fechar',
  'globalPartnersTitle': 'Colaborando com 30,000 Parceiros em Todo o Mundo',
  'globalPartnersDesc': 'Nossa extensa rede global de 30,000 parceiros impulsiona inovação compartilhada, troca de conhecimentos e sucesso mútuo. Trabalhando juntos, expandimos continuamente as fronteiras do cuidado do paciente.',
  'Yardım': 'Ajuda',
  'dil': 'Idioma',
  'Connect Free!': 'Conecte-se gratuitamente!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'Descubra nossos produtos mais populares',
  'Tüm Kategoriler': 'Todas as categorias',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 produtos exibidos (Total: 8000+)',
  'Tüm Ürünleri Gör →': 'Ver todos os produtos →',
  'Detaylar': 'Detalhes',
  'Sipariş Ver': 'Encomendar agora',
  'Giriş Yap': 'Entrar',
  'Hesabınıza giriş yapın': 'Entre na sua conta',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'Este site é protegido pelo reCAPTCHA e a Política de Privacidade e Termos de Serviço do Google se aplicam.',
  'Ürün Kataloğumuz': 'Nosso catálogo de produtos',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'Oferecemos mais de 8000 produtos',
  '1,3B': '1,3K',
  'Partner': 'Parceiro',
  '8,4M': '8,4M',
  'Toplam Üretim': 'Produção total',
  '23': '23',
  'Branş': 'Filial',
  '27,5B': '27,5K',
  'Toplam Sipariş': 'Pedidos totais',
  'Connect Now': 'Conectar agora',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'Registe-se gratuitamente para aceder a todas as informações num só local.',
  'Ürün Detayları': 'Detalhes do produto',
  'Kapat': 'Fechar',
  'Yükleniyor...': 'Carregando...',
  'Hata': 'Erro',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} produtos exibidos (Total: 8000+)',
  'Şehir Seçimi': 'Seleção de Cidade',
  'Firma / Sağlık Profesyoneli': 'Empresa / Profissional de Saúde',
  'Yetkili Kişi': 'Pessoa Autorizada',
  'Telefon': 'Telefone',
  'E-posta': 'Email',
  'Temel Bilgiler': 'Informações Básicas',
  'Ek Bilgiler': 'Informações Adicionais',
  'Faaliyet Alanı / Sektör': 'Área de Atividade / Setor',
  'Ülke Seçimi': 'Seleção de País',
  'Ülke adı veya kodu ara...': 'Pesquisar nome ou código do país...',
  'region.Avrupa': 'Europa',
  'region.Amerika': 'América',
  'region.Asya': 'Ásia',
  'region.Afrika': 'África',
  'region.Okyanusya': 'Oceania',
  'region.Diğer': 'Outro',
  'country.TR': 'Turquia',
  'country.US': 'Estados Unidos',
  'country.DE': 'Alemanha',
  'country.FR': 'França',
  'country.GB': 'Reino Unido',
  'country.IT': 'Itália',
  'country.ES': 'Espanha',
  'country.RU': 'Rússia',
  'country.CN': 'China',
  'country.JP': 'Japão',
  'country.KR': 'Coreia do Sul',
  'country.IN': 'Índia',
  'country.BR': 'Brasil',
  'country.CA': 'Canadá',
  'country.AU': 'Austrália',
  'Ticaret Sicil No': 'Número do Registro Comercial',

  'country.TR': 'Turquia',
  'country.AL': 'Albânia',
  'country.DE': 'Alemanha',
  'country.AD': 'Andorra',
  'country.AT': 'Áustria',
  'country.BY': 'Bielorrússia',
  'country.BE': 'Bélgica',
  'country.BA': 'Bósnia e Herzegovina',
  'country.BG': 'Bulgária',
  'country.CZ': 'República Tcheca',
  'country.DK': 'Dinamarca',
  'country.EE': 'Estônia',
  'country.FO': 'Ilhas Faroé',
  'country.FI': 'Finlândia',
  'country.FR': 'França',
  'country.GI': 'Gibraltar',
  'country.GR': 'Grécia',
  'country.GG': 'Guernsey',
  'country.HR': 'Croácia',
  'country.NL': 'Países Baixos',
  'country.IE': 'Irlanda',
  'country.ES': 'Espanha',
  'country.SE': 'Suécia',
  'country.CH': 'Suíça',
  'country.IT': 'Itália',
  'country.IS': 'Islândia',
  'country.JE': 'Jersey',
  'country.ME': 'Montenegro',
  'country.LV': 'Letônia',
  'country.LI': 'Liechtenstein',
  'country.LT': 'Lituânia',
  'country.LU': 'Luxemburgo',
  'country.HU': 'Hungria',
  'country.MT': 'Malta',
  'country.IM': 'Ilha de Man',
  'country.MD': 'Moldávia',
  'country.MC': 'Mônaco',
  'country.MK': 'Macedônia do Norte',
  'country.NO': 'Noruega',
  'country.PL': 'Polônia',
  'country.PT': 'Portugal',
  'country.RO': 'Romênia',
  'country.RU': 'Rússia',
  'country.SM': 'San Marino',
  'country.RS': 'Sérvia',
  'country.SK': 'Eslováquia',
  'country.SI': 'Eslovênia',
  'country.SJ': 'Svalbard e Jan Mayen',
  'country.UA': 'Ucrânia',
  'country.GB': 'Reino Unido',
  'country.VA': 'Cidade do Vaticano',
  'country.AX': 'Ilhas Åland',
  'country.US': 'Estados Unidos',
  'country.AS': 'Samoa Americana',
  'country.AI': 'Anguilla',
  'country.AG': 'Antígua e Barbuda',
  'country.AR': 'Argentina',
  'country.AW': 'Aruba',
  'country.BS': 'Bahamas',
  'country.BB': 'Barbados',
  'country.BZ': 'Belize',
  'country.BM': 'Bermudas',
  'country.BO': 'Bolívia',
  'country.BR': 'Brasil',
  'country.VG': 'Ilhas Virgens Britânicas',
  'country.CA': 'Canadá',
  'country.KY': 'Ilhas Cayman',
  'country.CL': 'Chile',
  'country.CO': 'Colômbia',
  'country.CR': 'Costa Rica',
  'country.CU': 'Cuba',
  'country.CW': 'Curaçao',
  'country.DM': 'Dominica',
  'country.DO': 'República Dominicana',
  'country.EC': 'Equador',
  'country.SV': 'El Salvador',
  'country.FK': 'Ilhas Malvinas',
  'country.GF': 'Guiana Francesa',
  'country.GD': 'Granada',
  'country.GL': 'Groenlândia',
  'country.GP': 'Guadalupe',
  'country.GT': 'Guatemala',
  'country.GY': 'Guiana',
  'country.HT': 'Haiti',
  'country.HN': 'Honduras',
  'country.JM': 'Jamaica',
  'country.MQ': 'Martinica',
  'country.MX': 'México',
  'country.MS': 'Montserrat',
  'country.NI': 'Nicarágua',
  'country.PA': 'Panamá',
  'country.PY': 'Paraguai',
  'country.PE': 'Peru',
  'country.PR': 'Porto Rico',
  'country.BL': 'São Bartolomeu',
  'country.KN': 'São Cristóvão e Névis',
  'country.LC': 'Santa Lúcia',
  'country.MF': 'São Martinho',
  'country.PM': 'São Pedro e Miquelon',
  'country.VC': 'São Vicente e Granadinas',
  'country.SX': 'Sint Maarten',
  'country.SR': 'Suriname',
  'country.TT': 'Trinidad e Tobago',
  'country.TC': 'Ilhas Turks e Caicos',
  'country.UY': 'Uruguai',
  'country.VE': 'Venezuela',
  'country.VI': 'Ilhas Virgens Americanas',
  'country.AF': 'Afeganistão',
  'country.AZ': 'Azerbaijão',
  'country.BH': 'Bahrein',
  'country.BD': 'Bangladesh',
  'country.AE': 'Emirados Árabes Unidos',
  'country.BN': 'Brunei',
  'country.BT': 'Butão',
  'country.CN': 'China',
  'country.TL': 'Timor-Leste',
  'country.ID': 'Indonésia',
  'country.AM': 'Armênia',
  'country.PH': 'Filipinas',
  'country.PS': 'Palestina',
  'country.GE': 'Geórgia',
  'country.KR': 'Coreia do Sul',
  'country.IN': 'Índia',
  'country.HK': 'Hong Kong',
  'country.IQ': 'Iraque',
  'country.IR': 'Irã',
  'country.IL': 'Israel',
  'country.JP': 'Japão',
  'country.KH': 'Camboja',
  'country.QA': 'Catar',
  'country.KZ': 'Cazaquistão',
  'country.KG': 'Quirguistão',
  'country.CY': 'Chipre',
  'country.KW': 'Kuwait',
  'country.KP': 'Coreia do Norte',
  'country.LA': 'Laos',
  'country.LB': 'Líbano',
  'country.MO': 'Macau',
  'country.MV': 'Maldivas',
  'country.MY': 'Malásia',
  'country.MM': 'Myanmar',
  'country.MN': 'Mongólia',
  'country.NP': 'Nepal',
  'country.UZ': 'Uzbequistão',
  'country.PK': 'Paquistão',
  'country.SG': 'Singapura',
  'country.LK': 'Sri Lanka',
  'country.SY': 'Síria',
  'country.SA': 'Arábia Saudita',
  'country.TJ': 'Tajiquistão',
  'country.TH': 'Tailândia',
  'country.TW': 'Taiwan',
  'country.TM': 'Turcomenistão',
  'country.OM': 'Omã',
  'country.JO': 'Jordânia',
  'country.VN': 'Vietnã',
  'country.YE': 'Iêmen',
  'country.DZ': 'Argélia',
  'country.AO': 'Angola',
  'country.BJ': 'Benim',
  'country.BW': 'Botswana',
  'country.BF': 'Burkina Faso',
  'country.BI': 'Burundi',
  'country.CV': 'Cabo Verde',
  'country.CM': 'Camarões',
  'country.CF': 'República Centro-Africana',
  'country.TD': 'Chade',
  'country.KM': 'Comoras',
  'country.CG': 'República do Congo',
  'country.CD': 'República Democrática do Congo',
  'country.CI': 'Costa do Marfim',
  'country.DJ': 'Djibuti',
  'country.EG': 'Egipto',
  'country.GQ': 'Guiné Equatorial',
  'country.ER': 'Eritreia',
  'country.SZ': 'Eswatini',
  'country.ET': 'Etiópia',
  'country.GA': 'Gabão',
  'country.GM': 'Gâmbia',
  'country.GH': 'Gana',
  'country.GN': 'Guiné',
  'country.GW': 'Guiné-Bissau',
  'country.KE': 'Quênia',
  'country.LS': 'Lesoto',
  'country.LR': 'Libéria',
  'country.LY': 'Líbia',
  'country.MG': 'Madagascar',
  'country.MW': 'Malawi',
  'country.ML': 'Mali',
  'country.MR': 'Mauritânia',
  'country.MU': 'Maurício',
  'country.YT': 'Mayotte',
  'country.MA': 'Marrocos',
  'country.MZ': 'Moçambique',
  'country.NA': 'Namíbia',
  'country.NE': 'Níger',
  'country.NG': 'Nigéria',
  'country.RE': 'Reunião',
  'country.RW': 'Ruanda',
  'country.SH': 'Santa Helena',
  'country.ST': 'São Tomé e Príncipe',
  'country.SN': 'Senegal',
  'country.SC': 'Seicheles',
  'country.SL': 'Serra Leoa',
  'country.SO': 'Somália',
  'country.ZA': 'África do Sul',
  'country.SS': 'Sudão do Sul',
  'country.SD': 'Sudão',
  'country.TZ': 'Tanzânia',
  'country.TG': 'Togo',
  'country.TN': 'Tunísia',
  'country.UG': 'Uganda',
  'country.EH': 'Saara Ocidental',
  'country.ZM': 'Zâmbia',
  'country.ZW': 'Zimbábue',
  'country.AU': 'Austrália',
  'country.CX': 'Ilha do Natal',
  'country.CC': 'Ilhas Cocos',
  'country.CK': 'Ilhas Cook',
  'country.FJ': 'Fiji',
  'country.PF': 'Polinésia Francesa',
  'country.GU': 'Guam',
  'country.HM': 'Ilhas Heard e McDonald',
  'country.KI': 'Kiribati',
  'country.MH': 'Ilhas Marshall',
  'country.FM': 'Micronésia',
  'country.NR': 'Nauru',
  'country.NC': 'Nova Caledônia',
  'country.NZ': 'Nova Zelândia',
  'country.NU': 'Niue',
  'country.NF': 'Isla Norfolk',
  'country.MP': 'Ilhas Marianas do Norte',
  'country.PW': 'Palau',
  'country.PG': 'Papua-Nova Guiné',
  'country.PN': 'Islas Pitcairn',
  'country.WS': 'Samoa',
  'country.SB': 'Ilhas Salomão',
  'country.TK': 'Tokelau',
  'country.TO': 'Tonga',
  'country.TV': 'Tuvalu',
  'country.VU': 'Vanuatu',
  'country.WF': 'Wallis e Futuna',
  'country.AQ': 'Antártida',
  'country.BV': 'Ilha Bouvet',
  'country.IO': 'Território Britânico do Oceano Índico',
  'country.TF': 'Terras Austrais Francesas',
  'country.GS': 'Geórgia do Sul e Ilhas Sandwich do Sul',
};
